module.exports = __webpack_public_path__ + "img/x-height-baseline.16e96646.jpg";